import { render, staticRenderFns } from "./identifier_create.vue?vue&type=template&id=66a31b94"
import script from "./identifier_create.vue?vue&type=script&lang=js"
export * from "./identifier_create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports